<template>
	<div class="row">
		<div class="mr-auto ml-auto  col-lg-10">
			<!-- <button class="btn btn-secondary">
        <i class="fa fa-file-excel-o" aria-hidden="true"/>
        {{ 'Download' | translate }}
      </button> -->
			<div class="table-responsive">
				<table class="table">
					<tr>
						<th>ID</th>
						<th>{{ 'Status' | translate }}</th>
						<th>{{ 'Payment Date' | translate }}</th>
						<th>{{ 'Payment Amount' | translate }}</th>
						<th>{{ 'Person' | translate }}</th>
						<th>{{ 'Students' | translate }}</th>
						<th>{{ 'Group' | translate }}</th>
						<th>{{ 'Actions' | translate }}</th>
					</tr>
					<tr v-for="profile in listProfiles" :key="profile.id">
						<td>{{ profile.id }}</td>
						<td></td>
						<td></td>
						<td></td>
						<td>
							<router-link
								:to="{ name: 'Dashboard Profile', params: { id: profile.id } }"
							>
								{{ profile.last_name }} {{ profile.first_name }}
							</router-link>
						</td>
						<td>
							<router-link
								v-for="children in profile.children"
								:key="children.id"
								:to="{ name: 'Dashboard Profile', params: { id: children.id } }"
								>{{ children.first_name }}
							</router-link>
						</td>
						<td>
							<router-link
								v-for="children in profile.children"
								:key="children.id"
								:to="{
									name: 'Dashboard Group Profile',
									params: { id: children.group },
								}"
								>{{ children.group_name }}
							</router-link>
						</td>
						<td>
							<!-- <a href="#">{{ 'Send invoice' | translate }}</a>
							<a href="#">{{ 'Download invoice' | translate }}</a> -->
							<a
								href="#"
								@click.prevent="openModal(profile.id, 'delete')"
								class="text-red outline outline-red"
								>{{ 'Block' | translate }}</a
							>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Parent',
	computed: {
		listProfiles() {
			return this.$store.state.profiles
		},
	},
	methods: {
		openModal(id, type) {
			let profileId = []
			profileId[0] = id
			this.$store.commit('changeModalId', profileId)
			this.$store.commit('changeModalType', type)
			this.$emit('openModal')
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 576px) {
	.offset-lg-1 > .btn {
		width: 100%;
		margin-bottom: 10px;
	}
}
</style>
